import { http } from '@noor/api';
import {
  courierListSchema,
  courierListResponseSchema,
  courierCountsDtoSchema,
  courierListItemSchema,
  courierParamsSchema,
  type CourierList,
  type CourierListResponse,
  type CourierCountsDto,
  type CourierListItem,
  type CourierParams,
  type UpdateCourierStatusPayload,
  type UpdateCourierPayload,
} from '../model/schema';

export const courierApi = {
  /** Fetch paginated fleet couriers with filters */
  async list(params?: CourierParams): Promise<CourierListResponse> {
    const parsed = courierParamsSchema.parse(params ?? {});
    const query: Record<string, string> = {
      tab: parsed.tab,
      page: String(parsed.page),
      pageSize: String(parsed.pageSize),
    };
    if (parsed.branch && parsed.branch !== 'all') query.branch = parsed.branch;
    if (parsed.date) query.date = parsed.date;
    if (parsed.search) query.search = parsed.search;

    const raw = await http.get<unknown>('admin/couriers', { query });
    return courierListResponseSchema.parse(raw);
  },

  /** Fetch badge counts for all 9 fleet tabs */
  async counts(): Promise<CourierCountsDto> {
    const raw = await http.get<unknown>('admin/couriers/counts');
    return courierCountsDtoSchema.parse(raw);
  },

  /** Fast status transition (e.g. block, unblock) */
  async updateStatus(
    id: string,
    payload: UpdateCourierStatusPayload,
  ): Promise<CourierListItem> {
    const raw = await http.patch<unknown>(`admin/couriers/${id}/status`, payload);
    return courierListItemSchema.parse(raw);
  },

  /** Update courier profile / branch assignment */
  async update(id: string, payload: UpdateCourierPayload): Promise<CourierListItem> {
    const raw = await http.patch<unknown>(`admin/couriers/${id}`, payload);
    return courierListItemSchema.parse(raw);
  },

  /** Legacy stub API list method */
  async legacyList(): Promise<CourierList> {
    const raw = await http.get<unknown>('couriers', {
      query: { page: '1', pageSize: '20' },
    });
    return courierListSchema.parse(raw);
  },
};
